export default theme => ({
  textField: {
    width: '100%',
    marginBottom: '9px'
  },
  smallTitle: {
    textTransform: 'none'
  }
});